import { put, call } from "redux-saga/effects";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";
import { URLS } from "../../services/apiServices/service";


  //-----------------------------------------------------------------------------------
export const getRtiTempletApi = function* getRtiTempletApiDataApi(action) {
  
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getRtiTempletDetailApi = function* getRtiTempletDetailApiData(action) {
  yield put({ type: "SHOW_LOADER" });

  let path = URLS.RTITEMPLETDETAIL + `/${action.id}`;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBackRtiDetail(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getRtiTempletMapDataApi = function* getRtiTempletMapApiData(action) {
  yield put({ type: "SHOW_LOADER" });

  let path = URLS.RTITEMPLETDETAIL + `/via_state?name=${action.state}`;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBackRtiMapData(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};